import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from 'axios';
import { dataUser } from "../Helpers/util";
import $ from 'jquery';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from "../../utils/axiosInstance";
import SwSelect from "../Common/SwReactSelect/SwReactSelect";
import SwTextArea from "../Common/FormComponent/SwTextArea";
import SwInput from "../Common/FormComponent/SwInput";
import SwOffCanvas from "../Common/SwOffCanvas/SwOffCanvas";
import SwButton from "../Common/SwButtons/SwButtons";
import AntDUpload from "../Common/AntDUpload/AntDUpload";
const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);


function RaiseTicket(props) {
    const [btnStatus, setButtonStatus] = useState(false);
    const [locationSpoc, setLocationSpoc] = useState([]);
    const [floorSpoc, setFloorSpoc] = useState([]);
    const [location1, setLocation1] = useState(null);
    const [location2, setLocation2] = useState('');
    const [locationId, setLocationId] = useState('');
    const [category, setCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [subCategory, setSubCategory] = useState(null);
    const [text, setText] = useState('');
    const [descriptionText, setDescriptionText] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [imageSrc, setImageSrc] = useState('');
    const [value, setValue] = useState('');
    const [files, setFiles] = useState([]);
    // const [attachmentError, setAttachmentError] = useState('');
    const [locationError, setLocationError] = useState('')
    const [floorError, setFloorError] = useState('')
    const [categoryError, setCategoryError] = useState('')
    const [textError, setTextError] = useState('')
    const [subCategoryError, setSubCategoryError] = useState('')
    const [fileId, setFileId] = useState('')





    useEffect(() => {
        const fetchData = async () => {
            try {
                let authToken = JSON.parse(localStorage.getItem('headData'));
                const axiosConfig = {
                    params: {
                        spoc: UserObj?.rec_id,
                        client: UserObj.company_id
                    },
                    headers: {
                        Authorization: `${authToken?.spintlyToken}`
                    }
                };

                const response = await axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`, axiosConfig);

                if (response.data.status === "success") {
                    setLocationSpoc(response.data.data);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);
    const handleLocationChange = async (selectedOption) => {
        setLocation1(selectedOption);
        // Set locationId first
        setLocationId(selectedOption.value);

        // Call floorData with the updated locationId
        await floorData(selectedOption.value);
        await categoryData(selectedOption.value);
        if (!selectedOption) {
            setLocationError("Location can't be empty");
        } else {
            setLocationError('');
        }
    };

    const handleFloorChange = async (selectedOption) => {
        setLocation2(selectedOption);
        await categoryData(locationId);
        if (!selectedOption) {
            setFloorError("Floor Name can't be empty");
        } else {
            setFloorError('');
        }
    };





    const handleText = (e) => {
        setText(e.target.value)
        if (e.target.value.trim()) {
            setTextError('');
        }
    }




    const handleDescription = (e) => {
        setDescriptionText(e.target.value)
    }
    const handleCategoryChange = async (selectedOption) => {

        setSelectedCategory(selectedOption);
        await categorySubData(locationId, selectedOption);
        if (!selectedOption) {
            setCategoryError("Issue Related to can't be empty");
        } else {
            setCategoryError('');
        }
        setSubCategory('')
    };
    const handleSubCategory = (selectedOption) => {
        setSubCategory(selectedOption)
        if (!selectedOption) {
            setSubCategoryError("Issue Related to can't be empty");
        } else {
            setSubCategoryError('');
        }
    };

    const categoryData = async (locationId) => {
        try {

            const data = {
                location: locationId,
                company_id: UserObj ? UserObj.company_id : null,
                ticketType: "spoc"
            };


            const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getCat`, data);
            setCategory(response.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    const floorData = async (locationId) => {
        try {


            const response = await axiosInstance.get(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/get-floorv2`, {
                params: {
                    location: locationId
                },

            });

            if (response.data.status === "success") {
                setFloorSpoc(response.data.data);
            }
        } catch (error) {
            console.error(error, 'svfjhdsgfj');
        }
    };

    const categorySubData = async (locationId, selectedCategory) => {
        try {

            const data = {
                location: locationId,
                company_id: UserObj ? UserObj.company_id : null,
                category: selectedCategory.value
            };


            const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getSubCat`, data);
            setSubCategoryData(response.data.data);
        } catch (error) {
            console.error(error);
        }
    };



    const handleFile = (e) => {
        const files = e.target.files;
        if (files.length > 0) {
            // Update selected file and file name
            setSelectedFile(files[0]);
            setSelectedFileName(files[0].name);
            // Update image source if needed
            setImageSrc(window.URL.createObjectURL(files[0]));
        }

        // Set the files state
        setFiles(files);

        // Check the number of files and set attachment error if necessary
        // if (files.length > 2) {
        //     setAttachmentError("Attachment can't be more than 2");
        // } else {
        //     setAttachmentError('');
        // }
    };
    const handleUploadChange = ({ fileList }) => {
        setFiles(fileList);
    };


    const handleRaiseTicket = async (e) => {
        e.preventDefault();
        setLocationError('');
        setFloorError('');
        setCategoryError('');
        setTextError('');
        setSubCategoryError('');
        let isValid = true;

        if (!location1) {
            setLocationError("Location can't be empty");
            isValid = false;
        }
        if (!location2) {
            setFloorError("Floor Name can't be empty");
            isValid = false;
        }
        if (!selectedCategory) {
            setCategoryError("Issue Related to can't be empty");
            isValid = false;
        }
        if (!text.trim()) {
            setTextError("Please state the issue");
            isValid = false;
        }
        if (!subCategory) {
            setSubCategoryError("Issue sub-category can't be empty");
            isValid = false;
        }

        if (isValid) {
            setButtonStatus(true)
            try {
                const requestData = {
                    locationCode: location1 ? location1.value : '',
                    category: selectedCategory ? selectedCategory.value : '',
                    subCategory: subCategory ? subCategory.value : '',
                    subject: text,
                    description: descriptionText,
                    userId: UserObj ? String(UserObj.rec_id) : '', // Convert rec_id to a string
                    userName: UserObj ? UserObj.fname + ' ' + UserObj.lname : '',
                    email: UserObj ? UserObj.email : '',
                    phone: UserObj ? UserObj.phone : '',
                    companyId: UserObj ? String(UserObj.company_id) : '',
                    companyName: UserObj ? UserObj.company_name : '',
                    floor: location2 ? location2.label : '' // Use the selected floor label as floor value
                };


                const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/addTicket`, requestData);

                if (response?.data?.statusValue === 200) {
                    setButtonStatus(false)
                    const ticketId = response.data.data.id;


                    for (const fileObj of files) {
                        const formData = new FormData();
                        formData.append('file', fileObj.originFileObj);

                        await axiosInstance.post(
                            `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/add-attachments`,
                            formData,
                            { params: { ticketId } }
                        );
                    }
                    setFiles([]);
                    props.ticketListApi();
                    document.querySelector('input[type="file"]').value = '';
                    // Show success toast

                    setTimeout(() => {
                        toast.success('Request is submitted successfully', {
                        });
                    }, 1000);

                    // Close modal
                    props.onClose();
                    resetValue();
                    $('.close').click();
                } else {
                    // Show error toast if the status is not 200
                    toast.error("Error adding ticket. Please try again later", {
                        // position: toast.POSITION.TOP_CENTER
                    });
                }
            } catch (error) {
                console.error(error);
                // Handle error, show error message, etc.
                toast.error("Error adding ticket. Please try again later", {
                    // position: toast.POSITION.TOP_CENTER
                });
            }
        }

        setSubCategory(null)
        setText('')
        setDescriptionText('')
    };
    const resetValue = () => {
        setLocation1(null);
        setLocation2('');
        setSelectedCategory('');
        setSubCategory('')
        setLocationError('');
        setText('')
        setDescriptionText('')
        setFloorError('');
        setCategoryError('');
        setTextError('');
        setSubCategoryError('');
        setFiles([]);
        document.querySelector('input[type="file"]').value = '';
    }
    return (
        <>
            <SwOffCanvas
                show={props.show}
                onHide={() => {
                    resetValue();
                    props.onClose();
                }}
                title="Raise a ticket"
                width="500px"
                id="myModalTicket"
                footer={
                    <>
                        <div className="OffCanvasFooter_Btns">
                            <SwButton

                                variant="dark-outline"
                                type="button"
                                onClick={resetValue}
                            >
                                Reset
                            </SwButton>


                            {btnStatus == false ? <SwButton

                                onClick={handleRaiseTicket}
                            >
                                Submit
                            </SwButton> :
                                <SwButton size="sm" disabled >
                                    <i class="fa fa-refresh fa-spin"></i> Processing </SwButton>}
                        </div>
                    </>
                }
            >
                <div className="SwFormGroup">
                    <form>
                        <div className="row">
                            {/* Location Name */}
                            <div className="col-md-12 ">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Location Name<span className="Required">*</span></label>
                                    <SwSelect
                                        value={location1}
                                        onChange={handleLocationChange}
                                        options={locationSpoc.map(item => ({
                                            value: item.centercode,
                                            label: item.location_name
                                        }))}
                                        placeholder="Select Location"
                                        isClearable={false}
                                    />
                                    <span className="SwTextDanger SwTextSmall">
                                        {locationError}
                                    </span>
                                </div>
                            </div>
                            {/* Floor Name */}
                            <div className="col-md-12 ">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Floor Name<span className="Required">*</span></label>
                                    <SwSelect
                                        value={location2}
                                        onChange={handleFloorChange}
                                        options={floorSpoc.map(item => ({
                                            value: item.rec_id,
                                            label: item.business_name
                                        }))}
                                        placeholder="Select Floor"
                                        isClearable={false}
                                    />
                                    <span className="SwTextDanger SwTextSmall">
                                        {floorError}
                                    </span>
                                </div>
                            </div>
                            {/* Issue Related to */}
                            <div className="col-md-12 ">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Issue Related to<span className="Required">*</span></label>
                                    <SwSelect
                                        value={selectedCategory}
                                        onChange={handleCategoryChange}
                                        options={category.map(item => ({
                                            value: item,
                                            label: item
                                        }))}
                                        placeholder="Select Issue Related to"
                                        isClearable={false}
                                    />
                                    <span className="SwTextDanger SwTextSmall">
                                        {categoryError}
                                    </span>
                                </div>
                            </div>
                            {/* Issue sub-category */}
                            <div className="col-md-12 ">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Issue sub-category<span className="Required">*</span></label>
                                    <SwSelect
                                        value={subCategory}
                                        onChange={handleSubCategory}
                                        options={subCategoryData.map(item => ({
                                            value: item,
                                            label: item
                                        }))}
                                        placeholder="Select Issue sub-category"
                                        isClearable={false}
                                    />
                                    <span className="SwTextDanger SwTextSmall">
                                        {subCategoryError}
                                    </span>
                                </div>
                            </div>
                            {/* Please state the issue */}
                            <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Please state the issue<span className="Required">*</span></label>
                                    <SwInput
                                        value={text}
                                        onChange={handleText}
                                        rows={1}
                                        placeholder='Enter state issue'
                                    />
                                    <span className="SwTextDanger SwTextSmall">
                                        {textError}
                                    </span>
                                </div>
                            </div>
                            {/* Description */}
                            <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
                                <div className="SwFormGroup">
                                    <label className="SwFormLabel">Description</label>
                                    <SwTextArea
                                        value={descriptionText}
                                        onChange={handleDescription}
                                        rows="4"
                                        placeholder="Enter Description"
                                    />
                                </div>
                            </div>
                            {/* Attachment */}
                            <div className="row mb-4">
                                <div className="col-md-8">
                                    <AntDUpload
                                        type="button"
                                        listType="picture"
                                        multiple
                                        fileList={files}
                                        onChange={handleUploadChange}
                                    >
                                        <SwButton variant="primary" icon={<i className='bi bi-upload'></i>}>Upload Documents</SwButton>
                                    </AntDUpload>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </SwOffCanvas>
        </>
    );
}

export default RaiseTicket;
